"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SelloutReleaseType_1 = require("../../../release/model/sellout/SelloutReleaseType");

var SelloutTerminationReportRowDTO_1 = require("../model/SelloutTerminationReportRowDTO");

var SelloutTerminationReportRowDTOConverter_1 = require("./SelloutTerminationReportRowDTOConverter");
/**
 * Implementation of {@link SelloutTerminationReportRowDTOConverter}.
 *
 * @author Jan Prokop
 */


var SelloutTerminationReportRowDTOConverterImpl =
/*#__PURE__*/
function (_SelloutTerminationRe) {
  _inherits(SelloutTerminationReportRowDTOConverterImpl, _SelloutTerminationRe);

  function SelloutTerminationReportRowDTOConverterImpl() {
    _classCallCheck(this, SelloutTerminationReportRowDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutTerminationReportRowDTOConverterImpl).apply(this, arguments));
  }

  _createClass(SelloutTerminationReportRowDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var schema = SelloutTerminationReportRowDTO_1.SelloutTerminationReportRowDTO.schema;
      return new SelloutTerminationReportRowDTO_1.SelloutTerminationReportRowDTO(schema.productExternalId.valueOfField(source), schema.productName.valueOfField(source), schema.siteExternalId.valueOfField(source), schema.siteName.valueOfField(source), schema.endDate.valueOfField(source), schema.reason.valueOfField(source), schema.selloutPrice.valueOfField(source), schema.priceValidFrom.valueOfField(source), schema.priceValidTo.valueOfField(source), schema.releaseType.valueOfField(source), schema.newSelloutTypes.valueOf(source.newSelloutTypes && conversions.asObjectList(source, 'newSelloutTypes', function (v) {
        return conversions.asEnum(v, SelloutReleaseType_1.SelloutReleaseType);
      })), schema.releaseId.valueOf(conversions.toClassReferenceId(source.releaseId)), schema.releaseName.valueOfField(source), schema.releaseWorkflowType.valueOfField(source));
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return Object.assign(Object.assign({}, source), {
        endDate: conversions.fromDate(source.endDate),
        releaseId: conversions.toDocumentReferenceId(source.releaseId),
        selloutPrice: conversions.fromBigNumber(source.selloutPrice),
        priceValidFrom: conversions.fromDate(source.priceValidFrom),
        priceValidTo: source.priceValidTo ? conversions.fromDate(source.priceValidTo) : null,
        newSelloutTypes: source.newSelloutTypes ? conversions.asObjectArray(source, 'newSelloutTypes', function (value) {
          return value;
        }) : null
      });
    }
  }]);

  return SelloutTerminationReportRowDTOConverterImpl;
}(SelloutTerminationReportRowDTOConverter_1.SelloutTerminationReportRowDTOConverter);

exports.SelloutTerminationReportRowDTOConverterImpl = SelloutTerminationReportRowDTOConverterImpl;